var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDollar = function SvgDollar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 8330",
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 53
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dollar_svg__a",
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#232d40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171e2d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3206"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3205"
  }, /*#__PURE__*/React.createElement("text", {
    "data-name": "\\u20B9",
    transform: "translate(19.805 21.048)",
    fill: "#ffc165",
    fontSize: 12,
    fontFamily: "Lexend-Regular, Lexend"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3,
    y: 0
  }, "\u20B9"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 743",
    fill: "none",
    stroke: "#ffc165",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26.5,
    r: 26.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26.5,
    r: 25.5
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3215",
    transform: "translate(3.878 3.878)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 188",
    cx: 22.622,
    cy: 22.622,
    r: 22.622,
    fill: "url(#dollar_svg__a)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7422"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7421"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon material-attach-money",
    d: "M23.137 21.166c-3-.781-3.969-1.588-3.969-2.844 0-1.442 1.336-2.447 3.572-2.447 2.355 0 3.228 1.125 3.307 2.778h2.924a5.274 5.274 0 0 0-4.247-5.038v-2.9h-3.968v2.858c-2.567.556-4.63 2.223-4.63 4.776 0 3.056 2.527 4.577 6.218 5.464 3.307.794 3.969 1.958 3.969 3.188 0 .913-.648 2.368-3.572 2.368-2.725 0-3.8-1.217-3.942-2.778h-2.912c.159 2.9 2.328 4.525 4.868 5.067v2.871h3.969v-2.845c2.58-.489 4.63-1.984 4.63-4.7.001-3.754-3.214-5.037-6.217-5.818Z",
    fill: "#ffc968"
  }))))));
};
export default SvgDollar;